import React, { useState } from 'react';
import { ESSButton } from '../Atoms/ESSButton';
import { ESSToast } from '../Atoms/Toast';

/**
 * ToastExample - Functional example of Toast component
 * Shows how to trigger toasts programmatically
 */
const ToastExample = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = (variant) => {
    const messages = {
      info: 'This is an informational message',
      success: 'Operation completed successfully!',
      warning: 'Please review this warning',
      error: 'An error has occurred',
    };

    const newToast = {
      id: Date.now(),
      variant,
      content: messages[variant],
    };

    setToasts([...toasts, newToast]);

    // Auto-remove after 5 seconds
    setTimeout(() => {
      setToasts((current) => current.filter((t) => t.id !== newToast.id));
    }, 5000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((t) => t.id !== id));
  };

  return (
    <div className="toast-example">
      <div className="toast-example__buttons">
        <ESSButton onClick={() => showToast('info')} size="sm">
          Show Info Toast
        </ESSButton>
        <ESSButton
          onClick={() => showToast('success')}
          size="sm"
          variant="positive"
        >
          Show Success Toast
        </ESSButton>
        <ESSButton
          onClick={() => showToast('warning')}
          size="sm"
          variant="negative"
        >
          Show Warning Toast
        </ESSButton>
        <ESSButton
          onClick={() => showToast('error')}
          size="sm"
          variant="accent"
        >
          Show Error Toast
        </ESSButton>
      </div>

      {/* Toast Container */}
      <div className="toast-example__container">
        {toasts.map((toast) => (
          <div key={toast.id} className="toast-example__item">
            <ESSToast
              variant={toast.variant}
              content={toast.content}
              onClose={() => removeToast(toast.id)}
            />
            <button
              onClick={() => removeToast(toast.id)}
              className="toast-example__close"
              aria-label="Close toast"
            >
              ×
            </button>
          </div>
        ))}
      </div>

      <style jsx>{`
        .toast-example__buttons {
          display: flex;
          gap: 0.5rem;
          flex-wrap: wrap;
          margin-bottom: 1rem;
        }

        .toast-example__container {
          position: fixed;
          top: 1rem;
          right: 1rem;
          z-index: 9999;
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          max-width: 400px;
        }

        .toast-example__item {
          position: relative;
          animation: slideIn 0.3s ease-out;
        }

        .toast-example__close {
          position: absolute;
          top: 0.5rem;
          right: 0.5rem;
          background: transparent;
          border: none;
          font-size: 1.5rem;
          line-height: 1;
          cursor: pointer;
          color: inherit;
          opacity: 0.7;
          padding: 0.25rem;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .toast-example__close:hover {
          opacity: 1;
        }

        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default ToastExample;
